import * as React from 'react';

/**
 * @param {Object} props
 * @param {boolean} props.activeSort
 */

export const SVGComponent = (props) => (
  <svg
    height={6.377}
    viewBox='0 0 8.469 6.377'
    width={8.469}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.26,1.746a1.45,1.45,0,0,1,2.264,0l2.782,3.478A1.45,1.45,0,0,1,9.174,7.578H3.61A1.45,1.45,0,0,1,2.478,5.223Z'
      data-name='Path 3225'
      fill={props?.activeSort ? '#007E75' : '#caced5'}
      id='Path_3225'
      transform='translate(-2.157 -1.201)'
    />
  </svg>
);
